export default class EventReservation {
    constructor(props = {}) {
        this.id = props.id || null;
        this.userId = props.userId || null;
        this.eventId = props.eventId || null;
        this.status = props.status || 'pending';
        this.email = props.email || '';
        this.name = props.name || '';
        this.phone = props.phone || '';
        this.paymentTypeId = props.paymentTypeId || null;
        this.paymentStatus = props.paymentStatus || 'unpaid';
        this.confirmationCode = props.confirmationCode || '';
        this.amount = props.amount || null;
        this.notes = props.notes || '';
        this.createdAt = props.createdAt || null;
        this.updatedAt = props.updatedAt || null;
        
        // Relations
        this.event = props.event || null;
        this.user = props.user || null;
        this.paymentType = props.paymentType || null;
    }

    export(opts = {}) {
        return {
            id: this.id,
            userId: this.userId,
            eventId: this.eventId,
            status: this.status,
            email: this.email,
            name: this.name,
            phone: this.phone,
            paymentTypeId: this.paymentTypeId,
            paymentStatus: this.paymentStatus,
            amount: this.amount,
            notes: this.notes
        };
    }
}
